/**
 * When two pieces of organizer copy say the same thing (owner-directed 2026-09-02).
 *
 * ## The defect this exists for
 *
 * An event carries a `name` and a `purpose`, and the console lets an organizer put the same words
 * in both — real records do it, and so do seeded ones. Three surfaces then printed those words
 * twice in a row, once as a heading and once as a subtitle: the donor's event page, every row of
 * the organization's calendar, and the organization page's main-event block. Two identical lines
 * stacked reads as a rendering fault, not as an organization with a short answer.
 *
 * ## Why it is this blunt, deliberately
 *
 * Trimmed and case-folded, and nothing more. "Friday Night Fundraiser" and "friday night
 * fundraiser " are one repetition on a screen whatever the database thinks, and that is the whole
 * claim being made here. Anything cleverer — stripping punctuation, comparing prefixes, measuring
 * similarity — starts discarding an organization's own words on a guess, and the words belong to
 * the organization. A purpose that genuinely elaborates on the name keeps every character of it.
 *
 * A null first argument is *not* an echo: absent copy is a different fact from repeated copy, and
 * the three callers each decide separately what to fall back to.
 */
export function echoes(candidate: string | null, heading: string): boolean {
  return (
    candidate !== null &&
    candidate.trim().toLocaleLowerCase() === heading.trim().toLocaleLowerCase()
  );
}
